import * as types from './types';

export function signInRequest(cpf, password) {
  return {
    type: types.SIGN_IN_REQUEST,
    payload: { cpf, password },
  };
}

export function signInSuccess(payload) {
  return {
    type: types.SIGN_IN_SUCCESS,
    payload,
  };
}

export function signFailure() {
  return {
    type: types.SIGN_IN_FAILURE,
  };
}

export function signOut() {
  return {
    type: types.SIGN_OUT,
  };
}

/**
 * ---------------------------------------------------
 * REVOKE TOKEN
 * ---------------------------------------------------
 */

export function revokeTokenRequest() {
  return {
    type: types.REVOKE_TOKEN_REQUEST,
  };
}
export function revokeTokenSuccess() {
  return {
    type: types.REVOKE_TOKEN_SUCCESS,
  };
}

export function revokeTokenFailure() {
  return {
    type: types.REVOKE_TOKEN_FAILURE,
  };
}

/**
 * ---------------------------------------------------
 * UPDATE PROFILE HOSPITAL
 * ---------------------------------------------------
 */

export function perfilInstituicaoUpdate(payload) {
  return {
    type: types.UPDATE_PROFILE_HOSP_REQUEST,
    payload,
  };
}
